

































































































































import {Component, Mixins} from 'vue-property-decorator';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import DefaultFormMixin from '@/views/DefaultFormMixin';
import {
  AvailableToDownloadReport, AvailableToDownloadReportData, CaseReportEmailsRetrieveResponse, CodeRetrieveResponse,
  CodesRetrieveResponse, CommonModelUtils,
  ReceiverRetrieveResponse
} from '@/model/CommonModel';
import SelectInput from '@/components/input/SelectInput.vue';
import CommonValidators from '@/validator/CommonValidators';
import CommonApi from '@/api/CommonApi';
import CaseApi from '@/api/CaseApi';
import TextInput from '@/components/input/TextInput.vue';
import PasswordInput from '@/components/input/PasswordInput.vue';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';
import TransferInput from '@/components/input/TransferInput.vue';
import {XML, CIOMS, JPN_APPENDIX} from '@/utils/Constants.ts';
import AdminApi from '@/api/AdminApi';

@Component({
  components: {
    CommonPromptDialog, CommonButton, SelectInput,
    TextInput, PasswordInput, BooleanCheckboxInput, TransferInput
  },
  mixins: [DialogEventsMixin, DefaultFormMixin],
})
export default class CaseReportEmailDialog extends Mixins(DialogEventsMixin, DefaultFormMixin) {
  private selectedReport: AvailableToDownloadReportData;
  private visible: boolean = false;
  private senders: CodesRetrieveResponse[] = [];
  private receivers: ReceiverRetrieveResponse[] = [];
  private ciomsOrientations: CodeRetrieveResponse[] = [];
  private ciomsDataOrderings: CodeRetrieveResponse[] = [];
  private receiverType: string = '';
  private emails: any = [];
  private consignees: any = [];
  private checkedPassword: boolean = false;

  private form: any = {
    data: {
      content: '',
      password: '',
      recipients: [],
      reportId: '',
      senderKey: '',
      receiverName: '',
      notation: '',
      ciomsOrientation: '',
      ciomsDataOrdering: ''
    },
    rules: {
      senderKey: [{
        validator: CommonValidators.required(this), trigger: 'change'
      }],
      receiverName: [{
        validator: CommonValidators.required(this), trigger: 'change'
      }],
      consignees: [{
        validator: this.requiredConsignee(this), trigger: 'change'
      }]
    }
  };

  private emailForm: any = {
    data: {
      newEmail: ''
    },
    rules: {
      newEmail: [
        {
          validator: CommonValidators.email(this), trigger: 'click',
        },
        {
          validator: this.duplicateCheckEmail(this), trigger: 'click',
        }
      ]
    }
  };

  get isVisible() {
    return this.visible;
  }

  get isReceiverDisable() {
    return this.$store.getters.isCroType && this.reportTypeIsXML && this.form.data.senderKey === '';
  }

  get reportTypeIsXML() {
    return this.visible && this.selectedReport.reportList.reportFormat === XML;
  }

  get reportTypeIsCIOMS() {
    return this.visible && this.selectedReport.reportList.reportId.includes(CIOMS);
  }

  get reportTypeIsJPNAPPENDIX() {
    return this.visible && this.selectedReport.reportList.reportId.includes(JPN_APPENDIX);
  }

  get notationVisible() {
    return this.reportTypeIsXML || this.reportTypeIsCIOMS || this.reportTypeIsJPNAPPENDIX;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('caseReportEmailDialog', (params: AvailableToDownloadReportData) => {
          this.selectedReport = params;
          this.form.data.reportId = this.selectedReport.reportList.reportId;
          return Promise.all([this.show(), this.retrieveNotation()]).finally(() => {
            this.visible = true;
            this.loading = false;
          });
        });

    this.$modal.getEventBus().$on('hideCaseReportEmailDialog', () => this.onCancel());
  }

  public show() {
    this.visible = true;
    this.loading = true;

    CaseApi.retrieveCaseReportEmails(this.$route.params.caseKey)
        .then((res: CaseReportEmailsRetrieveResponse) => {
          const emailList = CommonModelUtils.getOrDefault(res.data, {userList: []}).userList;
          this.emails = emailList.map((email: string) => {
            return {address: email};
          });
        });

    if (this.$store.getters.isCroType && this.reportTypeIsXML) {
      CommonApi.retrieveCodes('SENDER_LIST')
          .then((res: CodesRetrieveResponse) => {
            this.senders = CommonModelUtils.getOrDefault(res.data, {codeList: []}).codeList;
          });
    } else {
      const caseKey = this.$route.params.caseKey;

      return Promise.all([
        CaseApi.retrieveCaseReportEmailAndDownloadReceivers(this.$route.params.sponsorKey, {caseKey}),
        this.retrieveCiomsOptions()
      ]).then((values: [ReceiverRetrieveResponse, void]) => {
        this.receivers = CommonModelUtils.getOrDefault(values[0].data, {receiverList: []}).receiverList;
      });
    }
  }

  public onChangeSender(senderKey: string) {
    this.receivers = [];
    this.form.data.receiverName = '';
    this.receiverType = '';

    if (senderKey === '' || senderKey === undefined) {
      return;
    }

    const caseKey = this.$route.params.caseKey;
    CaseApi.retrieveCaseReportEmailAndDownloadReceivers(this.$route.params.sponsorKey, {caseKey, senderKey})
        .then((res: ReceiverRetrieveResponse) => {
          this.receivers = CommonModelUtils.getOrDefault(res.data, {receiverList: []}).receiverList;
        });
  }

  public onChangeReceiver(receiverName: string) {
    if (receiverName === '' || receiverName === undefined) {
      this.receiverType = '';
      return;
    }
    const selectedReceiver = this.receivers.find((item: any) => item.receiverName === receiverName);
    this.receiverType = CommonModelUtils.getOrDefault(selectedReceiver, {receiverType: ''}).receiverType;
  }

  public onChangeEmail(data: any = {selected: [], unSelected: []}) {
    this.consignees = data.selected;
    this.form.data.recipients = this.consignees;
    this.validateField('consignees');
  }

  public onAddNewEmail() {
    if (this.emailForm.data.newEmail === '') {
      return;
    }

    (this.$refs.emailForm as any).validate((valid: boolean) => {
      // 추가 하려고 하는 이메일이 중복되지 않을 경우, 정상적으로 CONSIGNEE LIST에 표시
      if (valid) {
        this.consignees.push({address: this.emailForm.data.newEmail});
        this.form.data.recipients = this.consignees;
        this.emailForm.data.newEmail = '';
      }
    });
    this.validateField('consignees');
  }

  private duplicateCheckEmail(vm: any, messageCode: string = 'message.case.caseReportEmailDialog.duplicateEmail') {
    return (rule: any, value: any, callback: any) => {
      if (this.emails.length > 0) {
        for (const email of this.emails) {
          if (email.address.toLowerCase() === this.emailForm.data.newEmail.toLowerCase()) {
            callback(new Error(vm.$root.$t(messageCode)));
          }
        }
      }

      if (this.consignees.length > 0) {
        for (const email of this.consignees) {
          if (email.address.toLowerCase() === this.emailForm.data.newEmail.toLowerCase()) {
            callback(new Error(vm.$root.$t(messageCode)));
          }
        }
      }

      callback();
    };
  }

  public requiredConsignee(vm: any, messageCode: string = 'message.commonValidator.required') {
    return (rule: any, value: any, callback: any) => {
      if (this.consignees.length === 0) {
        callback(new Error(vm.$root.$t(messageCode)));
      }
      callback();
    };
  }

  public onCheckPassword() {
    this.form.data.password = '';
    return !this.checkedPassword;
  }

  public onChangePassword() {
    return this.checkedPassword = false;
  }

  private onCancel() {
    this.visible = false;
  }

  public onSend(param: any) {
    this.validation(() => this.submit(param));
  }

  public submit(param: any) {
    const {$event, on, off} = param;
    const report: AvailableToDownloadReport = this.selectedReport.reportList;
    const customizedId = report.customizedId;
    const unblindedValueApplicable = this.$store.getters.unblind;
    const data = {
      ...this.form.data,
      unblindedValueApplicable
    };

    on();
    if (report.reportFormat === XML) {
      const receiverType = this.receiverType;
      const receiverName = this.form.data.receiverName;

      CaseApi.sendCaseReportEmail(this.$route.params.caseKey, data, {receiverType, receiverName})
          .then((res: any) => {
            if (res.success) {
              this.afterSubmitSuccess();
              this.onCancel();
            } else {
              return Promise.reject(res.errMsg);
            }
          })
          .catch((errMsg) => this.afterRequestFail(errMsg))
          .finally(() => {
            this.visible = false;
            off();
          });

    } else {
      CaseApi.sendCaseReportEmail(this.$route.params.caseKey, data, {customizedId, unblindedValueApplicable})
          .then((res: any) => {
            if (res.success) {
              this.afterSubmitSuccess();
              this.onCancel();
            } else {
              return Promise.reject(res.errMsg);
            }
          })
          .catch((errMsg) => this.afterRequestFail(errMsg))
          .finally(() => {
            this.visible = false;
            off();
          });
    }
  }

  public retrieveNotation() {
    return AdminApi.retrieveNotation(this.$route.params.sponsorKey)
        .then((res: any) => {
          this.form.data.notation = res.data.notation;
        });
  }

  public retrieveCiomsOptions() {
    const sponsorKey = this.$route.params.sponsorKey;

    return this.reportTypeIsCIOMS ? Promise.all([
          CommonApi.retrieveCodes('CIOMS_ORIENTATION'),
          CommonApi.retrieveCodes('CIOMS_DATA_ORDERING'),
          AdminApi.retrieveCiomsOrientation(sponsorKey),
          AdminApi.retrieveCiomsDataOrdering(sponsorKey)
        ]).then((values: [CodesRetrieveResponse, CodesRetrieveResponse, any, any]) => {
          this.ciomsOrientations = CommonModelUtils.getOrDefault(values[0].data, {codeList: []}).codeList;
          this.ciomsDataOrderings = CommonModelUtils.getOrDefault(values[1].data, {codeList: []}).codeList;
          this.form.data.ciomsOrientation = values[2].data.ciomsOrientation;
          this.form.data.ciomsDataOrdering = values[3].data.ciomsDataOrdering;
        })
        : Promise.resolve();
  }

  public afterClosed() {
    this.form.data.content = '';
    this.form.data.password = '';
    this.form.data.reportId = '';
    this.form.data.senderKey = '';
    this.form.data.receiverName = '';
    this.form.data.recipients = [];
    this.emailForm.data.newEmail = '';
    this.consignees = [];
    this.checkedPassword = false;
    this.loading = true;

    (this.$refs.form as any).resetFields();
    (this.$refs.emailForm as any).resetFields();
  }

  public destroyed() {
    this.$modal.getEventBus().$off('caseReportEmailDialog');
    this.$modal.getEventBus().$off('hideCaseReportEmailDialog');
  }
}
